import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react/index';

import '../buttons/buttons.scss';

@inject('appStore', 'emailLinkForm')
@observer
export class EmailLink extends Component {
    static defaultProps = {
        text: 'Email my progress',
        onOpen: null,
        primaryAction: false,
        modal: false,
        emailActionName: 'email'
    };

    static propTypes = {
        id: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        primaryAction: PropTypes.bool,
        modal: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired
    };

    openModal() {
        const { modal } = this.props;
        modal.current.wrappedInstance.openModal();
    };

    render() {
        const { text, id, emailActionName, primaryAction, fitContent } = this.props,
            classes = classNames({
                'ht-button': true,
                'ht-button--link': !primaryAction,
                'ht-button--linkprimary': primaryAction,
                'ht-button--fit-content': fitContent
            });

        return <>
            <button
                id={id}
                onClick={() => this.openModal()}
                className={classes}
                type='button'
                data-action={emailActionName}
            >
                {text}
            </button>
        </>;
    }
}
